import { render, staticRenderFns } from "./FInput.vue?vue&type=template&id=70c256c6&scoped=true&"
import script from "./FInput.vue?vue&type=script&lang=js&"
export * from "./FInput.vue?vue&type=script&lang=js&"
import style0 from "./FInput.vue?vue&type=style&index=0&id=70c256c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_css-loader@6.8.1_lodash@4.17.21_prettier@3.0.3_r_gaeimbjcwu57yzcey4waijeptq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c256c6",
  null
  
)

export default component.exports